import i18n from "i18next";
import type { FC } from "react";
import { useNavigate } from "react-router";

import { PrimaryButton } from "../../../../../components/Buttons/components/ActionButton";
import { ResourceName, ResourceVariant } from "../../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../../core/router/types/routerTypes";
import type { NoneOwnProps } from "../../../../../core/types";

export const AddAppProfileApac: FC<NoneOwnProps> = () => {
    const navigate = useNavigate();
    const onClick = () => navigate(`${BASE_PATH}/${ResourceName.APPLICATION_PROFILE_LISTS}/${ResourceVariant.APAC}/${FORM_ACTION.CREATE}`);

    return (
        <PrimaryButton name="addAppProfileXml_button" onClick={onClick} disabled={false}>
            {i18n.t("button.addAppProfileApac")}
        </PrimaryButton>
    );
};
